import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from '../../../../service/config.service';
import { DataService } from '../../../../service/data.service';
import { UserService } from '../../../../service/user.service';

@Component({
  selector: 'app-user-preferences-dialog',
  templateUrl: './user-preferences-dialog.component.html',
  styleUrls: ['./user-preferences-dialog.component.scss']
})
export class UserPreferencesDialogComponent {

  pageSize: FormControl;
  pageOptions: FormControl;

  constructor(
    public dialogRef: MatDialogRef<UserPreferencesDialogComponent>,
    public settings: ConfigService,
    private dataService: DataService,
    private userService: UserService
  ) {
    this.pageSize = new FormControl(this.settings.config.pagination.pageSize);
    this.pageOptions = new FormControl(this.settings.config.pagination.pageSizeOptions);
  }

  get sidenavCollapsedByDefault(): boolean {
    return !!this.dataService.user?.sidenavCollapsedByDefault;
  }

  onInputPageSize() {
    this.pageSize.setValue(this.pageSize.value.replace(/\D/g, ""));
    if (this.pageSize.value > 1000) {
      this.pageSize.setValue(1000)
    }
  }

  onChangePageSize() {
    this.settings.config.pagination.pageSize = this.pageSize.value;
    this.settings.save()
  }

  onInputPageOptions() {
    this.pageOptions.setValue(this.pageOptions.value.replace(/[^0-9,\s]/g, ""))
  }

  onChangePageOptions() {
    this.settings.config.pagination.pageSizeOptions = (this.pageOptions.value as string)
      .replace(/\s/g, "")
      .split(/,/)
      .map(Number)
      .sort((a, b) => a - b);
    this.pageOptions.setValue(this.settings.config.pagination.pageSizeOptions.join(", "));
    this.settings.save()
  }

  async onChangeSidenavCollapsedByDefault(collapsedByDefault: boolean) {
    const user = this.dataService.user;
    const company = this.dataService.company;
    if (!user || !company) {
      return;
    }
    user.sidenavCollapsedByDefault = collapsedByDefault;
    await this.userService.update(user, company);
  }

  close() {
    this.dialogRef.close();
  }
}
